import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const SymptomTracker = lazy(() => import("./SymptomTrackerPage"));

const SymptomTrackerPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <SymptomTracker />
    </Suspense>
  );
};

export default SymptomTrackerPageLazy;
